<ng-container>
  <app-ross-popup
    id="comOrganization"
    [organizations]="organizations"
    [applications]="applications"
  >
  </app-ross-popup>
</ng-container>
